import ChatModule from './../asyncChat';
import {
    getLanguageBasePath,
    inspectionFeature,
    isHPWidgetized,
    maxPage,
    movedPermanently,
    NOT_FOUND
} from 'Helpers/routeHelper';
import { isHomePage } from 'Helpers/olxAutos';
import { getIsBlackListedPath } from 'Helpers/routeHelper';
import { getStore } from 'Helpers/store';
import { intializelocationOnboardingStatus } from 'Actions/locationOnboarding';
import * as locationOnboardingConstants from 'Components/LocationOnboarding/constants';
import { PLATFORM } from 'Constants/device.APP_TARGET';
import Auth from '../Auth';
import { setLanguageOnboardingFlag } from 'Actions/api';
import { isAbsoluteUrl } from 'Helpers/url';
import { getIsCategoryDeprecated } from 'Helpers/categories';
import { IS_DESKTOP } from 'Constants/device.APP_TARGET';
import { setAutosCurrentPageName } from 'Actions/track';
import { AUTOS_SELL_PAGE_NAME } from 'Constants/sellLandingPage';
import { UserSession, EvaluationConstants, setCurrentTab, SeoHelper } from 'olx-autos-landing-page';
import SITE_CODES from 'Constants/siteCodes';
// import { checkLangPathParam } from 'Helpers/routeHelper';
import httpStatusCodes from 'http-status-codes';
import { legacyListingRoutesObj } from 'Constants/legacyRegexConstants';
import { PRODUCT } from 'Constants/constants';

/**
 * Returns true for buy tab in markets with CXE managed landing pages
 * Returns false for sell/finance tab in markets with CXE managed landing pages
 * Returns true for the rest of the cases
//  */
const showLocationOnboarding = ({ config, location }) => {
    const { olxAutos: { isHomePageWidgetized, urlKeywords = {}} = {}} = config || {};

    return (!!isHomePageWidgetized && urlKeywords.buy)
        ? (location?.pathname?.includes(urlKeywords.buy))
        : true;
};

const initializeLocationOnboarding = () => {
    const store = getStore();

    if (store) {
        const state = store.getState();
        const locationOnboardingStatus = state && state.locationOnboardingStatus;

        if (locationOnboardingStatus === locationOnboardingConstants.DEFAULT_VAL) {
            store.dispatch(intializelocationOnboardingStatus());
        }
    }
};

export const onEnterItem = ({ params, location: { pathname }}, replace, config) => {
    ChatModule.importChatWrapper().then(({ 'default': ChatWrapper }) => {
        ChatWrapper.createPromise(config?.chat?.newChat);
    });

    if (pathname.includes('gallery-navigation') && (
        !(config.olxAutos?.isMXCL || config.adpvAuto?.showNewDesign)
    )) {
        const itemPath = (params.slug) ? `/item/${params.slug}-iid-${params.id}` : `/item/${params.id}`;

        replace({
            pathname: `${getLanguageBasePath(params)}${itemPath}`,
            state: { status: httpStatusCodes.MOVED_TEMPORARILY }
        });
    }
};

export const onEnterApp = (nextState, replace, config) => {
    if (nextState.location.pathname?.indexOf('/amp/') != -1) {
        replace({
            pathname: nextState.location.pathname.replace(/\/amp\//, '/'),
            state: movedPermanently()
        });
    }
    if (!config.hideLocationOnboarding) {
        const isHP = nextState && nextState.location && isHomePage({
            location: nextState.location,
            urlKeywords: config?.olxAutos?.urlKeywords
        });
        const isBlackListedPathname = getIsBlackListedPath(nextState, config);

        if (!isBlackListedPathname && isHP && showLocationOnboarding({
            config,
            location: nextState?.location
        })) {
            initializeLocationOnboarding();
        }
    }
};

export const onChangeApp = (nextState, _, config) => {
    if (!config.hideLocationOnboarding) {
        const isBlackListedPathname = getIsBlackListedPath(nextState, config);

        if (!isBlackListedPathname && showLocationOnboarding({
            config,
            location: nextState?.location
        })) {
            initializeLocationOnboarding();
        }
    }
};

// export const onEnterMultilang = ({ location }, replace, config) => {
// const lang = location.basename && location.basename.replace('/', '');

// if (!lang || (lang && !checkLangPathParam(lang, config.langs))) {
//     replace({
//         pathname: '/notfound',
//         state: { status: httpStatusCodes.MOVED_TEMPORARILY }
//     });
// }
// };

export const onEnterListing = ({ location }, replace) => {
    maxPage(location, replace);
};

export const onEnterListing2 = ({ params, location }, replace, config) => {
    const { categoryID } = params;
    const isDeprecatedCategory = getIsCategoryDeprecated(categoryID, config.deprecatedCategories);

    if (isNaN(categoryID) || isDeprecatedCategory) {
        replace({
            pathname: '/notfound',
            state: isDeprecatedCategory ? NOT_FOUND : movedPermanently()
        });
    }
    else {
        maxPage(location, replace);
    }
};

export const onEnterListing4 = ({ params, location }, replace, config) => {
    const { categoryID } = params;
    const isDeprecatedCategory = getIsCategoryDeprecated(categoryID, config.deprecatedCategories);

    if (isNaN(params.geoID) || isNaN(categoryID) || isDeprecatedCategory) {
        replace({
            pathname: '/notfound',
            state: isDeprecatedCategory ? NOT_FOUND : movedPermanently()
        });
    }
    else {
        maxPage(location, replace);
    }
};

export const onEnterListing3 = ({ params, location }, replace) => {
    if (isNaN(params.geoID)) {
        replace({
            pathname: '/notfound',
            state: movedPermanently()
        });
    }
    else {
        maxPage(location, replace);
    }
};

export const onEnterListingMain = ({ location, params }, replace, config) => {
    const { matchedLegacyRoute = 'none' } = params;

    const func = {
        [legacyListingRoutesObj.SLUG_CATEGORY]: onEnterListing,
        [legacyListingRoutesObj.SLUG_CATEGORY_CLASSIFIED]: onEnterListing,
        [legacyListingRoutesObj.SLUG_GEO]: onEnterListing3,
        [legacyListingRoutesObj.SLUG_GEO_CLASSIFIED]: onEnterListing3,
        [legacyListingRoutesObj.SLUG_CATEGORY_ID]: onEnterListing2,
        [legacyListingRoutesObj.SLUG_CATEGORY_ID_CLASSIFIED]: onEnterListing2,
        [legacyListingRoutesObj.SLUG_GEO_CAT]: onEnterListing4,
        [legacyListingRoutesObj.SLUG_GEO_CAT_CLASSIFIED]: onEnterListing4,
        [legacyListingRoutesObj.SLUG_ITEM_ID]: () => {
            replace({
                pathname: `/item${location.pathname}`,
                state: httpStatusCodes.MOVED_TEMPORARILY
            });
        },
        [legacyListingRoutesObj.SLUG_ITEM_ID_CLASSIFIED]: () => {
            replace({
                pathname: `/item${location.pathname}`,
                state: httpStatusCodes.MOVED_TEMPORARILY
            });
        },
        [legacyListingRoutesObj.SLUG_LOCATION_ID]: () => {},
        [legacyListingRoutesObj.SLUG_LOCATION_ID_CLASSIFIED]: () => {},
        ['(:lang/)items(/q-:text)']: () => {},
        none: () => {
            replace({
                pathname: '/notfound',
                status: httpStatusCodes.NOT_FOUND
            });
        }
    }[matchedLegacyRoute];

    if (func) {
        func({ location, params }, replace, config);
    }
};

export const onEnterHome = ({ location }, replace, config) => {
    const isWidgetized = isHPWidgetized(config);

    maxPage(location, replace);
    if (!isWidgetized) {
        const store = getStore();

        store?.dispatch(setAutosCurrentPageName(''));
    }
};

export const onSetLanguageOnboardingFlag = () => {
    const store = getStore();

    if (store) {
        store.dispatch(setLanguageOnboardingFlag(true));
    }
};

export const onUnsetLanguageOnboardingFlag = () => {
    const store = getStore();

    if (store) {
        store.dispatch(setLanguageOnboardingFlag(false));
    }
};

export const onEnterInspection = (state, replace) => {
    inspectionFeature(PLATFORM, replace, state, Auth);
    onUnsetLanguageOnboardingFlag();
};

export const onEnterAccount = ({ params, location }, replace) => {
    if (Auth.isLoggedIn()) {
        const { to } = location.query;
        let pathname;

        if (to && !isAbsoluteUrl(to)) {
            pathname = `${getLanguageBasePath(params)}${to}`;
        }
        else {
            pathname = `${getLanguageBasePath(params)}/`;
        }

        replace({
            pathname,
            state: { status: httpStatusCodes.MOVED_TEMPORARILY }
        });
    }
};

export const onEnterOrders = (state, replace, config) => {
    if (config.monetizer.enabled) {
        Auth.requiresAuth(state, replace);
    }
    else {
        replace({
            pathname: `${getLanguageBasePath(state.params)}/error`,
            state: { status: httpStatusCodes.MOVED_TEMPORARILY }
        });
    }
};

export const onEnterSiteMap = ({ params, location }, replace, config) => {
    const { categoryID } = params;
    const { deprecatedCategories = [], product } = config;
    const isDeprecatedCategory = getIsCategoryDeprecated(categoryID, deprecatedCategories);

    if (isDeprecatedCategory) {
        replace({
            pathname: '/notfound',
            state: { status: httpStatusCodes.NOT_FOUND }
        });
    }

    if (!params.tabName && product !== PRODUCT.olxautos) {
        replace({
            pathname: `${location.pathname}/most-popular`,
            state: { status: httpStatusCodes.MOVED_PERMANENTLY }
        });
    }
};

export const onEnterCxeRoutes = ({ location, params }, replace, config) => {
    const olxAutos = config && config.olxAutos;

    if (!olxAutos) {
        replace({
            pathname: '/notfound',
            state: { status: httpStatusCodes.MOVED_PERMANENTLY }
        });
        return;
    }
    if (olxAutos.onlyMobile && IS_DESKTOP) {
        const queryParams = location.search || '';

        replace({
            pathname: `https://www.olx.in/olxautos${queryParams}`,
            state: { status: httpStatusCodes.MOVED_TEMPORARILY }
        });
        return;
    }
    const { seoTheme } = params;
    const seoInformation = SeoHelper.getSeoInformation(params, config);

    if (seoTheme && !seoInformation) {
        const sellOrganicRoute = config.landingPageRoutes && config.landingPageRoutes['sell-organic'];

        replace({
            pathname: sellOrganicRoute,
            state: { status: httpStatusCodes.MOVED_PERMANENTLY }
        });
    }
    const store = getStore();

    let intent = '';
    let tabName = '';
    let autosPageName = AUTOS_SELL_PAGE_NAME;
    const { USER_INTENT, TAB_NAME } = EvaluationConstants;

    if (location.pathname.includes(olxAutos?.urlKeywords?.sell)) {
        intent = USER_INTENT.SELLER;
        tabName = TAB_NAME.SELL;
        autosPageName = AUTOS_SELL_PAGE_NAME;
    }
    if (location.pathname.includes(olxAutos?.urlKeywords?.buy) || location.pathname.includes(olxAutos?.urlKeywords?.buyPPC)) {
        intent = USER_INTENT.BUYER;
        tabName = TAB_NAME.BUY;
        autosPageName = '';
    }
    if (
        location.pathname.includes(
            olxAutos?.urlKeywords?.finance
        )
        || location.pathname.includes(
            olxAutos?.urlKeywords?.financePPC
        )
    ) {
        tabName = TAB_NAME.FINANCE;
        autosPageName = '';
    }
    UserSession.setUserIntent(intent);
    if (store) {
        store.dispatch(setLanguageOnboardingFlag(false));
        store.dispatch(setCurrentTab(tabName));
        store.dispatch(setAutosCurrentPageName(autosPageName));
    }
    const userState = UserSession.getUserEvaluationState();

    if (userState === EvaluationConstants.EVALUATION_STATES.VALUATION_STARTED) {
        UserSession.setUserEvaluationState(EvaluationConstants.EVALUATION_STATES.INITIAL);
    }
};

export const onEnterValuation = (locationObj, replace, config) => {
    if (IS_DESKTOP) {
        const pathname = locationObj?.location?.pathname || '/sell-car';
        const search = locationObj?.location?.search || '';
        const path = pathname.replace('/valuation-flow', '');

        replace({
            pathname: path + search
        });
    }
    const store = getStore();
    const { USER_INTENT, TAB_NAME } = EvaluationConstants;

    UserSession.setUserIntent(USER_INTENT.SELLER);
    if (store) {
        store.dispatch(setLanguageOnboardingFlag(false));
        store.dispatch(setCurrentTab(TAB_NAME.SELL));
    }
    if (
        [
            SITE_CODES.OLX_ID,
            SITE_CODES.OLX_IN,
            SITE_CODES.OLX_AR,
            SITE_CODES.OLX_CO,
            SITE_CODES.OLX_PE,
            SITE_CODES.OLX_EC,
            SITE_CODES.OLX_TR
        ].includes(config.siteCode)
    ) {
        UserSession.setUserEvaluationState(EvaluationConstants.EVALUATION_STATES.VALUATION_STARTED);
        UserSession.initUserVisitStatus();
    }
};
